import { useEffect, useState } from 'react';

import {
  deleteGoldenDemand as deleteGoldenDemandService,
  getGoldenDemands,
  GoldenDemand,
} from '../services/goldenDemandService';

export const useGoldenDemands = () => {
  const [goldenDemands, setGoldenDemands] = useState<GoldenDemand[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchGoldenDemands = async () => {
    try {
      setLoading(true);
      const data = await getGoldenDemands();
      setGoldenDemands(data.gold_standards || []);
      setError(null);
    } catch (err) {
      console.error('Error fetching golden demands:', err);
      setError('Failed to load gold standards');
    } finally {
      setLoading(false);
    }
  };

  const deleteGoldenDemand = async (id: string) => {
    await deleteGoldenDemandService(id);
    await fetchGoldenDemands();
  };

  useEffect(() => {
    fetchGoldenDemands();
  }, []);

  return {
    goldenDemands,
    loading,
    error,
    refetch: fetchGoldenDemands,
    deleteGoldenDemand,
  };
};
